import React from "react";
import Carousel from "./carousel/Carousel";
import classes from './Home.module.css';
import About from "./about/About";
import Footer from "../../components/footer/Footer";
import Directions from "./directions/Directions";
// import Services from "./services/Services"; // COMMENTED OUT - backup saved in _backup folder
// import Testimonials from "./testimonials/Testimonials"; // COMMENTED OUT - will connect to Google reviews later

const Home = () => {
    return (
        <div className={classes.Container}>
            <Carousel />
            <About />
            {/* <Services /> */}
            {/* <Testimonials /> */}
            <Directions />
            <Footer />
        </div>
    )
}

export default Home;
